
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/technologies/[slug]",
      function () {
        return require("private-next-pages/preview/technologies/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/technologies/[slug]"])
      });
    }
  